import * as React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';

import './loading.css';

export default () => (
  <div className="loading-shading-mui">
    <CircularProgress color="inherit" className="loading-icon-mui" />
  </div>
);
